import 'slick-carousel';
import 'magnific-popup';
import AOS from 'aos';
import {CountUp} from 'countup.js';

/**
 * @file
 * A JavaScript file for the theme.
 *
 * In order for this JavaScript to be loaded on pages, see the instructions in
 * the README.txt next to this file.
 */
// JavaScript should be made compatible with libraries other than jQuery by
// wrapping it with an "anonymous closure". See:
// - https://drupal.org/node/1446420
// - http://www.adequatelygood.com/2010/3/JavaScript-Module-Pattern-In-Depth
(function (Drupal, $) {

  'use strict';

  // To understand behaviors, see https://drupal.org/node/756722#behaviors
  Drupal.behaviors.my_custom_behavior = {
    attach: function (context, settings) {
      Drupal.project.popupImage();
      Drupal.project.zoomGallery();
      Drupal.project.popupVideo();
      Drupal.project.popupAjax();
      Drupal.project.scrollHash();
      Drupal.project.showRounds();
      Drupal.project.showTeam();
      Drupal.project.classementsCircuit();
      Drupal.project.classementClubs();
      Drupal.project.classementEtape();
      Drupal.project.search_open();
      Drupal.project.search_close();
    }
  };

  Drupal.project = {};

  /**
   * Function popup image
   */
  Drupal.project.popupImage = function () {
    $('.image-popup').magnificPopup({
      type: 'image',
      removalDelay: 300,
      mainClass: 'mfp-fade',
    });
  };

  /**
   * Function Diaporama gallery
   */
  Drupal.project.zoomGallery = function () {
    $('.diapo-gallery').each(function () {
      $(this).magnificPopup({
        delegate: 'a',
        type: 'image',
        removalDelay: 300,
        mainClass: 'mfp-fade',
        gallery: {
          enabled: true,
          navigateByImgClick: true,
          preload: [0, 1]
        },
        image: {
          tError: '<a href="%url%">The image #%curr%</a> could not be loaded.'
        }
      });
    });
  };

  /**
   * Function popup video
   */
  Drupal.project.popupVideo = function () {
    $('.video-popup').magnificPopup({
      disableOn: 700,
      type: 'iframe',
      removalDelay: 160
    });
  };

  Drupal.project.popupAjax = function () {
    $('.ajax-popup').magnificPopup({
      type: 'ajax',
      overflowY: 'auto',
      closeBtnInside: true,
      mainClass: 'mfp-fade',
    });
  };

  /**
   * Animation ancres
   * @param anchor
   */
  Drupal.project.scrollHash = function (name) {
    let anchor = $("[name=" + name + "]");
    if (anchor.length) {
      let heightElements = 0;
      $("html, body").animate({scrollTop: anchor.offset().top - heightElements}, 1000);

    }

  }

  Drupal.project.showRounds = function () {
    $('article.interclubs .nav-tabs li a').click(function () {
      let tabs = $(this);
      $.ajax('', {
        url: '/interclubs/rounds?id_rounds=' + $(this).attr('data-rounds'),
        beforeSend: function () {
          //Mettre le loader
          $('.b-loader').show(0);
        },
        success: function (data, status) {
          $('article.interclubs .nav-tabs li a').removeClass('active');
          tabs.addClass('active');
          $('article.interclubs .data-draws').html(data);
          Drupal.project.showTeam();
        },
        complete: function () {
          //Cacher le loader
          $('.b-loader').hide(0);
        },
        error: function (data, status) {
          console.log(data, status);
        }
      });
    });
  }

  Drupal.project.showTeam = function () {
    $('article.interclubs  a.link-team').click(function () {
      $.ajax('', {
        url: '/interclubs/team?id_team=' + $(this).attr('data-team'),
        beforeSend: function () {
          //Mettre le loader
          $('.b-loader').show(0);
        },
        success: function (data, status) {
          $('article.interclubs .data-draws').html(data);
          Drupal.project.scrollHash('top-interclubs');
          Drupal.project.showTeam();
          Drupal.project.popupAjax();
        },
        complete: function () {
          //Cacher le loader
          $('.b-loader').hide(0);
        },
        error: function (data, status) {
          console.log(data, status);
        }
      });
    });
  }

  Drupal.project.classementsCircuit = function () {
    $('article.circuit  a.general').click(function () {
      let tabs = $(this);
      $.ajax('', {
        url: '/circuit/classements?event_id=' + $(this).attr('data-event'),
        beforeSend: function () {
          //Mettre le loader
          $('.b-loader').show(0);
        },
        success: function (data, status) {
          $('article.circuit .nav-tabs li a').removeClass('active');
          tabs.addClass('active');
          $('article.circuit .data-circuit').html(data);
          Drupal.project.scrollHash('top-circuit');
          Drupal.project.popupAjax();
        },
        complete: function () {
          //Cacher le loader
          $('.b-loader').hide(0);
        },
        error: function (data, status) {
          console.log(data, status);
        }
      });
    });
  }

  Drupal.project.classementClubs = function () {
    $('article.circuit  a.club').click(function () {
      let tabs = $(this);
      $.ajax('', {
        url: '/circuit/club/classement?event_id=' + $(this).attr('data-event'),
        beforeSend: function () {
          //Mettre le loader
          $('.b-loader').show(0);
        },
        success: function (data, status) {
          $('article.circuit .nav-tabs li a').removeClass('active');
          tabs.addClass('active');
          $('article.circuit .data-circuit').html(data);
          Drupal.project.scrollHash('top-circuit');
        },
        complete: function () {
          //Cacher le loader
          $('.b-loader').hide(0);
        },
        error: function (data, status) {
          console.log(data, status);
        }
      });
    });
  }

  Drupal.project.classementEtape = function () {
    $('article.circuit  a.etape').click(function () {
      let tabs = $(this);
      $.ajax('', {
        url: '/circuit/etape/classement?event_id=' + $(this).attr('data-event') + '&etape_id=' + $(this).attr('data-etape') + '&etape_name=' + $(this).attr('data-etape-name'),
        beforeSend: function () {
          //Mettre le loader
          $('.b-loader').show(0);
        },
        success: function (data, status) {
          $('article.circuit .nav-tabs li a').removeClass('active');
          tabs.addClass('active');
          $('article.circuit .data-circuit').html(data);
          Drupal.project.scrollHash('top-circuit');
        },
        complete: function () {
          //Cacher le loader
          $('.b-loader').hide(0);
        },
        error: function (data, status) {
          console.log(data, status);
        }
      });
    });
  }

  Drupal.project.search_open = function () {
    $('.b-search .loupe').click(function(){
      $(this).hide();
      $('.b-search .close').show();
      $('#block-club-search').show(200);
    });
  }

  Drupal.project.search_close = function () {
    $('.b-search .close').click(function(){
      $(this).hide();
      $('.b-search .loupe').show();
      $('#block-club-search').hide(200);
    });
  }

  $(document).ready(function () {

    AOS.init({
      duration: 600,
    });

    $("article table").each(function () {
      if (!$(this).parent().hasClass('b-table')) {
        $(this).wrap('<div class="b-table"></div>');
      }
    });

    /**
     * Bloc slider contenu
     */
    if ($('.b-slider').length) {
      let $slider = $('.b-slider');


      $slider.slick({
        nextArrow: '<button type="button" class="next-item"><span class="visually-hidden">Previous</span><span class="material-icons">keyboard_arrow_right</span></button>',
        prevArrow: '<button type="button" class="prev-item"><span class="visually-hidden">Next</span><span class="material-icons">keyboard_arrow_left</span></button>',
        dots: true,
      });

      $slider.init(function () {
        AOS.refresh();
      });

    }

    /**
     * Bloc slider partners
     */
    if ($('.slide-partners').length) {
      let $sliderPartners = $('.slide-partners .items');
      $sliderPartners.slick({
        autoplay: true,
        autoplaySpeed: 2000,
        slidesToShow: 6,
        slidesToScroll: 1,
        prevArrow: $('.slide-partners .prev-item'),
        nextArrow: $('.slide-partners .next-item'),
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 3,
            }
          },
          {
            breakpoint: 768,
            settings: {
              prevArrow: false,
              nextArrow: false,
              slidesToShow: 2,
              autoplay: true,
            }
          }
        ],
      });
    }

    /**
     * Bloc slider instagram
     */
    if ($('.b-slider-instagram').length) {
      let $sliderInstagram = $('.b-slider-instagram .list-posts');
      $sliderInstagram.slick({
        autoplay: false,
        infinite: false,
        slidesToShow: 3,
        slidesToScroll: 3,
        prevArrow: $('.b-slider-instagram .prev-item'),
        nextArrow: $('.b-slider-instagram .next-item'),
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 2,
            }
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 1,
            }
          }
        ],
      });
    }


    if ($('.hub_events').length) {

      if ($(window).width() < 768) {
        setTimeout(function () {
          if ($('.full-calendar .fc-listMonth-button').length) {
            $('.full-calendar .fc-listMonth-button').trigger("click");
          }
        }, 1500);
      }

    }


    if ($('#b-iframe').length) {

      window.addEventListener('message', receiveMessage, false);

      function receiveMessage(event) {

        $('#b-iframe').css('height', event.data.frameHeight + 82 + 'px');

      }
    }

    if ($('article.interclubs').length) {
      setTimeout(function () {
        $('article.interclubs .nav-tabs li:first-child a').trigger('click');
      }, 100);
    }

    if ($('article.circuit').length) {
      setTimeout(function () {
        $('article.circuit .nav-tabs .general').trigger('click');
      }, 100);
    }

    $('html').on('click', '.bt-show', function () {
      let heightDatas = $(this).siblings('.datas').height();
      let colonne = $(this).parent();
      $(this).hide();
      colonne.animate({
        height: heightDatas + 70,
      }, 600, function () {
        colonne.addClass('open');
        colonne.children('.bt-hide').show();
      });
    });

    $('html').on('click', '.bt-hide', function () {
      let colonne = $(this).parent();
      $(this).hide();
      colonne.removeClass('open');
      colonne.animate({
        height: 300,
      }, 400, function () {
        colonne.children('.bt-show').show();
      });
    });

    $(".anchor-top").click(function () {
      $("html, body").animate({
        scrollTop: 0
      }, 1000);
      return false;
    });

    //CountUp
    $('.b-number').each(function (index) {
      let options = {
        startVal: $(this).attr('data-start'),
        duration: $(this).attr('data-duration'),
        enableScrollSpy: true,
        scrollSpyOnce: false,
      };
      let counter = new CountUp($(this).attr('id'), $(this).text(), options);
      counter.handleScroll();
    });

    //Menu history
    $('.menu-history span.select').click(function () {
      $(this).toggleClass('actif');
      $(this).siblings('ul').slideToggle(300);
    })

    $(window).scroll(function () {
      if ($(this).scrollTop() > 600) {
        $(".anchor-top").addClass('show');
      }
      else {
        $(".anchor-top").removeClass('show');
      }
    });

    //Accordions
    $('html').on('click', '.paragraph--type--bloc-accordion .top', function () {
      let accordeon = $(this).parent();
      if (accordeon.parent().attr('data-multiple') == 1) {
        accordeon.toggleClass('open');
        accordeon.children('.text').slideToggle(300);
      }
      else {
        if (accordeon.hasClass('open')) {
          $('.paragraph--type--bloc-accordion').removeClass('open');
          $('.paragraph--type--bloc-accordion .text').slideUp();
        }
        else {
          $('.paragraph--type--bloc-accordion').removeClass('open');
          $('.paragraph--type--bloc-accordion .text').slideUp();
          accordeon.addClass('open');
          accordeon.children('.text').slideDown(300);
        }
      }
    });

    //Palmarès : voir la suite des résultats
    $('html').on('click', '.palmares-toggle', function () {
      let $btn = $(this);
      $btn.closest('.mod-palmares').find('.palmares-more').slideToggle(300);
      if ($btn.text().trim() === 'Voir la suite du palmarès') {
        $btn.text('Voir moins de résultats');
      }
      else {
        $btn.text('Voir la suite du palmarès');
      }
    });


  });


})(Drupal, jQuery);
